import { gql } from '@apollo/client';

const GET_ORG_UNIT_INFO = gql`
  query GetOrgUnitInfo($id: Int!) {
    mddapOrgUnit(id: $id) {
      Name
      IsActive
      MddapOrganization {
        Name
      }
    }
  }
`;

export default GET_ORG_UNIT_INFO;
